import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';
import { ParticipantWithSigningProperties } from '@app/store/transport-layer/types/participant';
import { WithId } from '@app/store/transport-layer/types/utility';

interface GetDocumentsParticipantsParam {
  workspaceId: string;
  documentId: string;
}

export interface GetDocumentsParticipantsResponse {
  count: number;
  participants: WithId<ParticipantWithSigningProperties>[];
}

/**
 *
 * Endpoint is declared on standardize-document-content
 * @see https://www.notion.so/modusign/bb8e24e723434ecc946dfecb85db5ee3#21e1b9726efc49c5a38818783c915b0f
 */
export function getDocumentsParticipants({
  documentId,
  workspaceId,
}: GetDocumentsParticipantsParam) {
  return requestApi<GetDocumentsParticipantsResponse>({
    url: withDocument(`/workspaces/${workspaceId}/documents/${documentId}/participants`),
    method: 'GET',
    credentials: true,
  }).then((response) => response.data);
}

interface GetDocumentsParticipantsByIdParams {
  workspaceId: string;
  documentId: string;
  participantId: string;
}

/**
 *
 * Endpoint is declared on standardize-document-content
 * @see https://www.notion.so/modusign/bb8e24e723434ecc946dfecb85db5ee3#96830b9c16af488e9ed7e4331fa30385
 */
export function getDocumentsParticipantsById({
  workspaceId,
  documentId,
  participantId,
}: GetDocumentsParticipantsByIdParams) {
  return requestApi<WithId<ParticipantWithSigningProperties>>({
    url: withDocument(
      `/workspaces/${workspaceId}/documents/${documentId}/participants/${participantId}`
    ),
    method: 'GET',
    credentials: true,
  }).then((response) => response.data);
}

interface DeleteDocumentFromWorkspaceResponse {
  requestCount: number;
  deletedCount: number;
  failedCount: number;
}

export function deleteDocumentFromWorkspace({
  workspaceId,
  documentIds,
}: {
  workspaceId: string;
  documentIds: string[];
}) {
  return requestApi<DeleteDocumentFromWorkspaceResponse>({
    url: withDocument(`/workspaces/${workspaceId}/documents/delete`),
    method: 'POST',
    credentials: true,
    data: { documentIds },
  }).then((response) => response.data);
}
